// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var CloudReflash = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M8.646 5.116a.5.5 0 0 1 .704.061l1.928 2.282a.49.49 0 0 1 .002.636l-.064.063-2.298 1.914c-.212.176-.527.149-.704-.061s-.15-.523.062-.699l1.493-1.244-.023-.002a3.5 3.5 0 0 0-2.496.804c-1.481 1.234-1.674 3.425-.431 4.895s3.45 1.662 4.931.428A3.45 3.45 0 0 0 13 11.538a.5.5 0 0 1 1 .003 4.44 4.44 0 0 1-1.608 3.413c-1.904 1.586-4.742 1.339-6.34-.551s-1.349-4.708.555-6.294a4.5 4.5 0 0 1 3.037-1.043l-1.06-1.252a.493.493 0 0 1 .062-.699z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4 14c-2.25-.276-4-2.184-4-4.5a4.5 4.5 0 0 1 3.006-4.246 5 5 0 0 1 9.899-1.231 3.5 3.5 0 0 1 3.09 3.286L16 7.5a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-2.21-2.483l-.725-.083-.142-.716a4.002 4.002 0 0 0-7.924.783L4 5.103l.041.847-.704.248A3.5 3.5 0 0 0 .999 9.501c0 1.768 1.32 3.258 3.065 3.5h1.935v1z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(CloudReflash);
export default ForwardRef;
